import React from "react";
import styled from "styled-components";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import circleX from "../../assets/circleX.svg";

export function Dialog({ children, ...props }) {
  return (
    <DialogPrimitive.Root {...props}>
      <StyledOverlay />
      {children}
    </DialogPrimitive.Root>
  );
}

export const DialogContent = React.forwardRef(
  ({ children, ...props }, forwardedRef) => (
    <DialogPrimitive.Content {...props} ref={forwardedRef}>
      {children}
    </DialogPrimitive.Content>
  )
);

const StyledOverlay = styled(DialogPrimitive.Overlay)`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* opacity: 0.7; */
  background: hsl(231, 87%, 12%, 0.4);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;
